import gql from 'graphql-tag';

const REFRESH_AUDIENCE_CSV = gql`
  mutation refreshAudienceCsv($id: ID!, $orgID: ID!) {
    refreshAudienceCsv(data: { id: $id, orgID: $orgID })
  }
`;

export default REFRESH_AUDIENCE_CSV;
